import { normalizeText } from './filters';

export const frotaHasMotorista = (frota, motoristaSelecionado) => {
  if (!motoristaSelecionado) return true;

  return (frota.motoristas || []).some(motorista => (
    (motoristaSelecionado.codigo && motorista.codigo === motoristaSelecionado.codigo)
    || (motoristaSelecionado.cpf && motorista.cpf === motoristaSelecionado.cpf)
    || (motoristaSelecionado.motorista && normalizeText(motorista.nome) === normalizeText(motoristaSelecionado.motorista))
  ));
};

export const isSameMotorista = (a, b) => {
  if (!a || !b) return false;
  return Boolean(
    (a.codigo && b.codigo && a.codigo === b.codigo)
    || (a.cpf && b.cpf && a.cpf === b.cpf)
    || (a.motorista && b.motorista && normalizeText(a.motorista) === normalizeText(b.motorista))
  );
};

export const isSameFrota = (a, b) => {
  if (!a || !b) return false;
  return Boolean(
    (a.codigo && b.codigo && a.codigo === b.codigo)
    || (a.protocolo && b.protocolo && a.protocolo === b.protocolo)
    || (a.placa && b.placa && normalizeText(a.placa) === normalizeText(b.placa))
    || (a.veiculo && b.veiculo && normalizeText(a.veiculo) === normalizeText(b.veiculo))
  );
};

export const frotaHasRelatedFrota = (frota, frotaSelecionada) => {
  if (!frotaSelecionada) return true;
  if (isSameFrota(frota, frotaSelecionada)) return true;

  const hasSharedMotorista = (frota.motoristas || []).some(motorista => (
    (frotaSelecionada.motoristas || []).some(item => (
      (motorista.codigo && item.codigo === motorista.codigo)
      || (motorista.cpf && item.cpf === motorista.cpf)
      || (motorista.nome && normalizeText(item.nome) === normalizeText(motorista.nome))
    ))
  ));

  if (hasSharedMotorista) return true;

  const isLinked = (origem, destino) => (origem?.reboques || []).some(reboque => (
    (reboque.codigo && destino.codigo && reboque.codigo === destino.codigo)
    || (reboque.protocolo && destino.protocolo && reboque.protocolo === destino.protocolo)
    || (reboque.placa && destino.placa && normalizeText(reboque.placa) === normalizeText(destino.placa))
  ));

  return isLinked(frota, frotaSelecionada) || isLinked(frotaSelecionada, frota);
};

export const motoristaHasFrota = (motorista, frotaSelecionada) => {
  if (!frotaSelecionada) return true;
  return (frotaSelecionada.motoristas || []).some(item => (
    (motorista.codigo && item.codigo === motorista.codigo)
    || (motorista.cpf && item.cpf === motorista.cpf)
    || (motorista.motorista && normalizeText(item.nome) === normalizeText(motorista.motorista))
  ));
};

export const isSameSelection = (selecaoAtiva, tipo, item) => {
  if (!selecaoAtiva || selecaoAtiva.tipo !== tipo) return false;
  return tipo === 'motorista' ? isSameMotorista(selecaoAtiva.item, item) : isSameFrota(selecaoAtiva.item, item);
};

export const applyCrossSelection = (data, tipoPainel, selecaoAtiva) => {
  if (!selecaoAtiva || selecaoAtiva.tipo === tipoPainel) return data;

  if (tipoPainel === 'motorista') {
    return data.filter(item => motoristaHasFrota(item, selecaoAtiva.item));
  }

  if (selecaoAtiva.tipo === 'motorista') {
    return data.filter(item => frotaHasMotorista(item, selecaoAtiva.item));
  }

  return data.filter(item => frotaHasRelatedFrota(item, selecaoAtiva.item));
};

export const filtrarPorCategoria = (itens, categoriaAtiva) => {
  if (!categoriaAtiva) return itens;
  return itens.filter(item => item.categoria === categoriaAtiva);
};

export const getCategoriaPainel = (categoriaAtiva, tipoPainel) => {
  if (!categoriaAtiva) return null;

  if (categoriaAtiva === 'carreta') {
    return tipoPainel === 'reboque' ? categoriaAtiva : null;
  }

  return tipoPainel === 'tracao' ? categoriaAtiva : null;
};
